export default __webpack_public_path__ + "static/media/phone.93272567.png";